namespace GeniuzPOS.Purchase {
    export interface ReportDailyPIData extends Serenity.ListRequest {
        para?: string;
        Shop?: string;
        DatetoDate?: string;
        Supdata?: string;
        ListHd?: ReportDailyPIRow[];
    }
}
